import routes from "../routes";

/**
 * @returns {{admin:{id:number,profile_id:number,name:string,email:string,status:number},permissions:{perm:{write: boolean,edit: boolean,read: boolean,remove: boolean}[]}}} admin e permissões
 */
export const adminData = () => {
    let admin = JSON.parse(sessionStorage.getItem("admin"));
    let permissions = JSON.parse(sessionStorage.getItem("permissions"));

    if (!admin || !permissions) {
        routes.push({ name: "signin" });
    }

    let logo = "https://sistemclinupload.s3.amazonaws.com/3bc79a07533bb2f38f3a6704240d4de2-6763ea9adfbaf8d1f7f483560e5aea5d-LOGO.png.png"

    return { admin, permissions, logo };
}

/**
     * formata números para o formato real R$0,00
     * @param {Number} value valor a ser formatado
     */
export function formatBRLCurrency(value) {
    if (!value) return null;
    return value.toLocaleString("pt-BR", {
        currency: "BRL",
        currencyDisplay: "symbol",
        style: "currency",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
}

export function dialogConfirm(text, callback) {
    this.$vs.dialog({
        color: "warning",
        title: "Confirmação",
        text: text,
        acceptText: "Confirmar",
        accept: callback,
    });
}

/**
 * @param {any[]} arr
 * @param {number} index
 * @param {number} new_index
 */
export function arraySwapItemPosition(arr, index, new_index) {
    arr[index] = arr.splice(new_index, 1, arr[index])[0];
    return arr;
}